import http from '../../Utils/http';

const isHiddenVisibility = (row = {}) => {
  console.log('row', row);
  const visibilityValue = [
    row?.visibility
  ].find((v) => v !== undefined && v !== null && String(v).trim() !== '');

  if (visibilityValue !== undefined) {
    return String(visibilityValue).trim().toLowerCase() === 'hidden';
  }

  return row?.isHidden === true || row?.hidden === true;
};

const normalizeUnreviewedRows = (payload) => {
  const rows =
    Array.isArray(payload) ? payload :
      Array.isArray(payload?.rows) ? payload.rows :
        Array.isArray(payload?.displays) ? payload.displays :
          [];

  return rows
    .map((row) => ({
      id: row?.id ?? row?.display_id,
      ...row,
    }))
    .filter((row) => {
      const reviewed = row?.isReviewed;
      if (reviewed === true) return false;
      if (String(reviewed).toLowerCase() === 'true') return false;
      return true;
    })
    .filter((row) => !isHiddenVisibility(row))
    .filter((row) => row?.id !== undefined && row?.id !== null);
};

const NewInventory = {
  name: 'NewInventory',
  state: {
    loading: false,
    rows: [],
    error: null,
    lastFetchedAt: null,
  },
  reducers: {
    requestStarted(state) {
      return {
        ...state,
        loading: true,
        error: null,
      };
    },
    requestSucceeded(state, payload) {
      return {
        ...state,
        loading: false,
        rows: payload?.rows || [],
        error: null,
        lastFetchedAt: Date.now(),
      };
    },
    requestFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload || 'Failed to fetch new inventory',
      };
    },
    clearState(state) {
      return {
        ...state,
        loading: false,
        rows: [],
        error: null,
        lastFetchedAt: null,
      };
    },
  },
  effects: () => ({
    async fetchUnreviewedByAdvertiser({ adv_id } = {}) {
      if (!adv_id) return { success: false, rows: [] };

      try {
        this.requestStarted();
        const resp = await http.get(`savvy/displays/adv-displays/unreviewed/${adv_id}`);
        const payload = resp?.data?.data ?? resp?.data ?? [];
        const rows = normalizeUnreviewedRows(payload);
        this.requestSucceeded({ rows });
        return { success: true, rows };
      } catch (err) {
        this.requestFailed(err?.message || 'Failed to fetch unreviewed displays');
        return { success: false, rows: [] };
      }
    },
  }),
};

export default NewInventory;
